module.exports = __webpack_public_path__ + "static/media/puzzle0502.b0a9490f.png";